export const ICON_MAPPING = {
  elevator: { x: 0, y: 0, width: 500, height: 500, mask: true },
  poi: { x: 510, y: 0, width: 500, height: 500, mask: true },
  stairs: { x: 1020, y: 0, width: 500, height: 500, mask: true },
  atm: { x: 1530, y: 0, width: 500, height: 500, mask: true }
};
